import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { showToast } from "../components/ToastNotification";

const ConfirmAccount = () => {
    const navigate = useNavigate();

    useEffect(() => {
        showToast("Your account is now activated. Please log in now!");
        const timeout = setTimeout(() => {
            navigate("/auth/signin");
        }, 4000);

        return () => clearTimeout(timeout);
    }, [navigate]);

    return (
        <div className="flex flex-col items-center justify-center bg-gray-50 flex-1">
            <div className="bg-white p-8 rounded-md shadow-md text-center max-w-md">
                <h1 className="text-2xl font-semibold text-green-600 mb-4">Your Account Activated</h1>
                <p className="text-gray-700">
                    Your account has been successfully confirmed. You'll be redirected to login shortly.
                </p>
            </div>
        </div>
    );
};

export default ConfirmAccount;
